import axios from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";
import { showApiErrorToast } from "../utils/helpers";
import { toast } from "react-toastify";

const createAdvancedSurvey = async ({ name, survey_json }) => {
  const token = localStorage.getItem("token");

  const URL = `${__API_URL__}/api/survey/advanced-surveys/create/`;

  const res = await axios.post(
    URL,
    { name, survey_json },
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return res.data;
};

const useCreateAdvancedSurveyMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createAdvancedSurvey,
    onSuccess: () => {
      queryClient.removeQueries({ queryKey: ["advanced_surveys"] });
      toast.success("Survey created successfully");
    },
    onError: (error) => {
      showApiErrorToast(error, "Failed to create survey");
    },
  });
};

export default useCreateAdvancedSurveyMutation;
